
import { FaFacebookF } from '@react-icons/all-files/fa/FaFacebookF';
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter';
import { FaLinkedinIn } from '@react-icons/all-files/fa/FaLinkedinIn';
import { FaPinterestP } from '@react-icons/all-files/fa/FaPinterestP';
import { FaRedditAlien } from '@react-icons/all-files/fa/FaRedditAlien';
import { format, parseISO } from 'date-fns';

export function SocialShare({ siteName, shareTitle, shareSummary, shareImage, tagList, twitterUsername, url, updatedAt }) {

  //  Source: https://cloudcannon.com/blog/lightweight-social-share-buttons/
  //  Encode URL params: https://stackoverflow.com/questions/8135132/how-to-encode-url-parameters
  //   site name (source)
  // - siteName

  // title of the post
  // - shareTitle

  // summary / description of the post
  // - shareSummary

  // (media) Image to share
  // - shareImage

  // (tags) is a comma separated list of tags
  // - tagList

  // Twitter username of the author or site (without “@”)
  // - twitterUsername
  // console.log({updatedAt})

  const handleFacebookShare = () => {
    const winHeight = 436;
    const winWidth = 626;
    const winTop = (screen.height / 2) - (winHeight / 2);
    const winLeft = (screen.width / 2) - (winWidth / 2);
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
  }

  const TwitterShareURL = twitterUsername ? `https://twitter.com/intent/tweet?url=${url}&text=${shareTitle}&via=${twitterUsername}` : `https://twitter.com/intent/tweet?url=${url}&text=${shareTitle}`

  //  Twitter - https://twitter.com/intent/tweet?url={}&text={}&via={}`
  const handleTwitterShare = () => {
    window.open(
      `${TwitterShareURL}`);
  }

  // LinkedIn - https://www.linkedin.com/shareArticle?mini=true&url={}&title={}&summary={}&source={}
  const handleLinkedInShare = () => {
    window.open(
      'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + shareTitle + '&source=' + siteName + '&summary=' + shareSummary);
  }

  //  PinTrest - https://www.pinterest.com/pin/create/button/?url={}&media={}&description={}
  const handlePintrestShare = () => {
    window.open(
      'https://pinterest.com/pin/create/button/?url=' + url + '&media=' + shareImage + '&description=' + shareSummary);
  }

  // Reddit - https://reddit.com/submit?url={}&title={}&resubmit=true
  const handleRedditShare = () => {
    window.open(
      'https://reddit.com/submit?url=' + url + '&title=' + shareTitle + '&resubmit=true');
  }

  return (
    <footer className='flex flex-wrap items-center pb-4 mb-8 border-b-2 lg:mb-8 md:flex-nowrap md:pb-0 border-b-gray-100 md:border-none'>
      {/* Last Update */}
      <div className='items-center flex-none text-xs font-bold tracking-wider text-gray-500 uppercase'>
        <span>Last updated</span>
        <span className='mx-1 text-gray-400' aria-hidden='true'>•</span>
        <span>
          {/* <time dateTime="2021-09-01 00:00:00 UTC"> Sep 1, 2021 </time> */}
          <time dateTime={updatedAt}>{format(parseISO(updatedAt), 'MMM do, yyyy')}</time>
        </span>
      </div>

      {/* border */}
      <div className='flex items-center flex-auto w-full mx-4'>
        <span className='w-full h-[2px] bg-gray-100 hidden md:block'></span>
      </div>

      {/* share icons */}
      <div className="flex flex-wrap items-center flex-none my-auto">

        <div className="items-center flex-none mr-1 text-xs font-bold tracking-wider text-gray-500 uppercase">Share</div>

        <span className="text-xl">
          {/* flex items-center justify-center transition-colors w-7 h-7 hover:text-blue-500 */}
          <button type="button" onClick={() => handleFacebookShare()} className='block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-blue-600' aria-label='Share on Facebook'>
            <FaFacebookF />
          </button>
        </span>

        <span className="text-xl">
          <button type="button" onClick={() => handleTwitterShare()} className='block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-blue-300' aria-label='Share on Twitter'>
            <FaTwitter />
          </button>
        </span>

        <span className="text-xl ">
          <button type="button" onClick={() => handleLinkedInShare()} className='block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-blue-500' aria-label='Share on LinkedIn'>
            <FaLinkedinIn />
          </button>
        </span>

        <span className="text-xl ">
          <button type="button" onClick={() => handlePintrestShare()} className='block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-pink-600' aria-label='Share on Pinterest'>
            <FaPinterestP />
          </button>
        </span>

        <span className="text-xl ">
        <button type="button" onClick={() => handleRedditShare()} className='block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-red-500' aria-label='Share on Reddit'>
            <FaRedditAlien />
          </button>
        </span>

      </div>

    </footer>
  )
}
